// ***********************************
// Main.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      
      <div>
            <b-button v-if="false"
              variant="link"
              v-b-modal.whatsnew
            >What's New</b-button>
            <b-modal id="whatsnew" title="What's New" ok-only size="xl">
                <div>
<b-list-group>
  <b-list-group-item>December 2022 - Added support for multiple scenarios in the Auto-Right-Sizer.</b-list-group-item>
  <b-list-group-item>November 2022 - Added gp3 support.</b-list-group-item>
  <b-list-group-item>August 2022 - Added multi-region support.  Added support for RDS Custom pricing.  Add cost-optimization arrows to the auto-right-sizer.  Fixed issue with Aurora shape throughput values (thanks to Pini D and Jobin J).</b-list-group-item>
  <b-list-group-item>June 2022 - Improved PDB support.  Added support for Tshapes in auto-right-sizer.</b-list-group-item>
  <b-list-group-item>May 2022 - Added support for collecting metrics from a PDB database. Added OLTP-DW and Exadata spectrum indicators to Auto-Right-Sizer.</b-list-group-item>
  <b-list-group-item>March 2022 - Added more help text. Bug fixes.</b-list-group-item>
  <b-list-group-item>January 2022 - Added sizing for OracleSE2 License Included. Fixed bug in aws_awr_miner.sql (thanks to Pini D).</b-list-group-item>
  <b-list-group-item>November 2021 - Aurora right-sizing now matches target Throughput to compute shape network throughput.  Added Next Closest Match for RDS and Aurora shapes.</b-list-group-item>
  <b-list-group-item>October 2021 - Added choice of sizing/tuning adjustment assumptions when migrating from Exadata.</b-list-group-item>
  <b-list-group-item>September 2021 - Simplified the UI for the Auto-Right-Sizer.  Added the ability to size for Aurora.  Added suggestions for PostgreSQL and SE2 to the auto-right-sizer.</b-list-group-item>
  <b-list-group-item>July 2021 - Added Print button to the Show Config dialog in the Auto-Right-Sizer.</b-list-group-item>
  <b-list-group-item>June 2021 - Added ability to Auto-Right-Size individual databases.</b-list-group-item>
  <b-list-group-item>May 2021 - Added ability to share a batch of databases with other userids.  Removed limitation of 1000 data points per chart (useful for databases with 15 minute AWR intervals).</b-list-group-item>
</b-list-group>
                </div>
            </b-modal>
      </div>
      <div>
        <router-link :to="{ name: 'Main'}">List</router-link> | 
        <router-link :to="{ name: 'Add'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> |
        <router-link :to="{ name: 'Shapes' }">ShapeBrowser</router-link> |
        <router-link :to="{ name: 'API' }">API</router-link> 
      </div>
      Switch to the <router-link :to="{ name: 'BatchHome'}">batch list view</router-link>.<br/><br/>

      

DB CSI is currently investigating {{ this.num_dbs }} unique databases from {{ this.num_customers }} customers.  <b-button v-b-toggle.morefacts variant="link">Click here to see more facts.</b-button>

  <b-collapse id="morefacts">
    <div id="demo">
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <b-table striped hover bordered fixed :items="platforms" :fields="platformfields" class="table table-sm"></b-table>
            <br>
            <b-table striped hover bordered fixed :items="instances" :fields="instancefields" class="table table-sm"></b-table>
          </b-col>
          
          <b-col>
            <b-table striped hover bordered fixed :items="versions" :fields="versionfields" class="table table-sm"></b-table>
            <br>
            <b-table striped hover bordered fixed :items="features" :fields="featurefields" class="table table-sm"></b-table>
          </b-col>
        </b-row>

        
      </b-container>
    </div>
  </b-collapse>  


      <div>
        <b-form-select v-model="CustomerFilter" :options="CustomerChoices" @change="onCustomerChange">
<!--          <template v-slot:first>
            <b-form-select-option :value="null">Show ALL</b-form-select-option>
          </template> -->
        </b-form-select>
        <br>
        <b-input-group prepend="Search" size="sm" style="max-width: 400px; margin-top: 8px;">
          <b-form-input v-model="searchString" placeholder="Search by name, description, or customer" @keyup.enter="doSearch"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="doSearch">Go</b-button>
            <b-button variant="outline-secondary" @click="clearSearch" v-if="searchString">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
        <br>
      </div>
      
    
            <router-link v-if="this.CustomerFilter != 'xxALL'"
              :to="{ name: 'Batch', params: {batch_id: 'x'+stringToHex(this.CustomerFilter)} }"
            >Auto-Right-Size all databases for {{this.CustomerFilter}}</router-link>

              <br>
              <br>
      <b-card-group v-for="cgroup in collection_group_filtered" :key="cgroup.group_id">
        <b-card
          v-for="item in cgroup.collection_list"
          :key="item.collection_id"
          :title="item.db_name"
          :sub-title="item.customer"
        >
          <div v-if="item.collection_id>0">
            <p class="card-text">
              {{item.version}}<span v-if="item.total_size!=undefined">, {{item.total_size}}</span>
               <img v-if="(item.script_ver != undefined && !( item.script_ver.includes('aws') || item.script_ver.includes('statspack') ) )" src="@/assets/warning.png" height="16px" v-b-tooltip.hover title="Warning: This looks like the generic non-DBCSI AWR Miner script was used to collect metrics.  DBCSI works best if you use the DBCSI-specific data collection script downloadable from the DBCSI Add page.  Some DBCSI functionality will be missing."></img>
              <br/>
              {{item.descr}}
              <br>
              Upload Date: {{item.collection_date}}
              <br>
              Upload User: {{item.upload_user}}
              <br>
              Status: {{item.status}}
            </p>
            <b-card v-if="(item.ec2_shape!=null && item.ec2_shape!='null' )||( item.rds_shape!=null && item.rds_shape!='null') ||( item.aurora_shape!=null && item.aurora_shape!='null')" title="AWS Mapping" bg-variant="warning"  >
              <b-row v-if="item.ec2_shape!='null'">
                <b-col v-b-tooltip.hover :title="item.ec2_summaryText">
                Re-host to EC2={{item.ec2_shape}}
                </b-col>
              </b-row>
               <b-row v-if="item.rds_shape!='null'">
                <b-col v-b-tooltip.hover :title="item.rds_summaryText">
              Re-platform to RDS={{item.rds_shape}}
                </b-col>
               </b-row>
               <b-row v-if="( item.aurora_shape!=null && item.aurora_shape!='null')">
                <b-col v-b-tooltip.hover :title="item.aurora_summaryText">
              Re-architect to Aurora={{item.aurora_shape}}
                </b-col>
               </b-row>
              </b-card>

            <router-link v-if="(item.status=='Ready')"
              class="card-link"
              :to="{ name: 'Batch', params: {batch_id: item.batch_id} }"
            >Auto-Right-Size</router-link>
            <br/>
            <router-link v-if="(item.status=='Ready' && item.ec2_shape==null)"
              class="card-link"
              :to="{ name: 'Metrics', params: {param_collection_id: item.collection_id, collection_type: 'ora_v1'} }"
            >Manual-Right-Size(View Metrics)</router-link>
            <router-link v-if="(item.status.startsWith('Failed'))"
              class="card-link"
              :to="{ name: 'Metrics', params: {param_collection_id: item.collection_id, collection_type: 'ora_v1'} }"
            >Click here to delete</router-link>

            <router-link v-if="item.status=='Ready' && item.ec2_shape!=null"
              class="card-link"
              :to="{ name: 'Metrics', params: {param_collection_id: item.collection_id, collection_type: 'ora_v1'} }"
            >View Metrics/Mapping</router-link>
            
              <br/>
              <b-button
                v-if="(item.status=='Ready')"
                type="button"
                size="sm"
                variant="link"
                v-b-modal="`mGenInfo${item.collection_id}`"
                 :disabled="item.collection_id==undefined"
              >...</b-button>
              <b-modal :id="`mGenInfo${item.collection_id}`" title="Database Details" scrollable ok-only size="xl">
                  
                  <generalinfomodal 
                    :param_collection_id="`${item.collection_id}`"
                    collection_type="ora_v1"
                    :user="user"
                  ></generalinfomodal>
              </b-modal>   
              
              
              <img v-if="(item.PLATFORM_NAME=='AIX-Based_Systems_(64-bit)')" src="@/assets/AIX.png" height="16px" ></img>
              <img v-if="(item.PLATFORM_NAME=='Solaris[tm]_OE_(64-bit)')" src="@/assets/SPARC.png" height="16px" ></img>
              <img v-if="(item.PLATFORM_NAME=='HP-UX_IA_(64-bit)')" src="@/assets/HPUX.png" height="16px" ></img>
              <img v-if="(item.PLATFORM_NAME=='IBM_zSeries_Based_Linux')" src="@/assets/zSeries.png" height="16px" ></img>
              <img v-if="(item.PLATFORM_NAME=='Microsoft_Windows_x86_64-bit')" src="@/assets/WIN.png" height="16px" ></img>
              <img v-if="(item.PLATFORM_NAME=='Solaris_Operating_System_(x86-64)')" src="@/assets/SolarisX86.png" height="16px" ></img>
              
              <img v-if="(item.EXADATA=='Yes')" src="@/assets/Exadata.png" height="20px" ></img>
              
              <img v-if="(item.IS_PDB=='YES')" src="@/assets/PDB.png" height="20px" ></img>
                 

            </div>
        </b-card>
      </b-card-group>

      <div v-if="false" class="container" style="margin-bottom: 2cm;">
        <!--<b-button-->
        <!--        v-b-toggle.showCalc-->
        <!--        size="sm"-->
        <!--        variant="link"-->
        <!--      >EC2 and RDS Estimator</b-button>-->
        <!--      <b-collapse id="showCalc">-->
        <!--        <calculator2/>-->
        <!--        </b-collapse>-->
      </div>
      
    </div>
  </div>
</template>    


<script>
import { API } from "aws-amplify";
import Calculator2 from '@/components/Calculator';
import GeneralInfoModal from "./GeneralInfoModal.vue";
export default {
  name: "app",
  components: {
    calculator2: Calculator2,
    generalinfomodal: GeneralInfoModal
  },
  props: ["user"],
  data() {
    return {
      num_dbs: 0,
      num_customers: 0,
      collection_group: [
        {
          group_id: 0,
          collection_list: [
            {
              collection_id: "0",
              db_name: "Please wait while we refresh data.  It may take a few minutes..."
              // db_type: "Oracle",
              // collection_type: "ora_v1",
              // status: "processed",
              // descr: "another collection example",
              // collection_date: "2018-12-14 15:00:19",
              // customer: "Octank Gaming"
            }
          ]
        }
      ],
      platforms: [
        { platform: "Loading...",
          num_dbs: 0
        } ],
      platformfields: [
        {platform: {
          label: "Platform",
          sortable: true
        }},
        {num_dbs: {
          label: "Databases",
          sortable: true
        }}
      ],      
      versions: [
        { version: "Loading...",
          num_dbs: 0
        } ],
      versionfields: [
        {version: {
          label: "Version",
          sortable: true
        }},
        {num_dbs: {
          label: "Databases",
          sortable: true
        }}
      ],      
      features: [
        { feature: "Loading...",
          num_dbs: 0
        } ],
      featurefields: [
        {feature: {
          label: "Feature",
          sortable: true
        }},
        {num_dbs: {
          label: "Databases",
          sortable: true
        }}
      ],      
       instances: [
        { inst_count: "Loading...",
          num_dbs: 0
        } ],
      instancefields: [
        {inst_count: {
          label: "# of Instances (RAC)",
          sortable: true
        }},
        {num_dbs: {
          label: "Databases",
          sortable: true
        }}
      ],      
        
      collection_list: [
            {
              collection_id: "0",
              db_name: "Please wait while we refresh data.  It may take a few minutes..."
              // db_type: "Oracle",
              // collection_type: "ora_v1",
              // status: "processed",
              // descr: "another collection example",
              // collection_date: "2018-12-14 15:00:19",
              // customer: "Octank Gaming"
            }
          ],
      CustomerFilter: 'xxALL',
      searchString: '',
      CustomerChoices: [
          { value: 'xxALL', text: 'Show ALL' },
          { value: 'd', text: 'Loading your list of customer names...', disabled: true }
      ]
    };
  },
  async created() {
    // console.log("Main: I am here1");
    
    var tries = 10;
    
    while (tries > 0) {
      // now load summary
      await API.get(
        "dbcsiAPI",
        `/dbcsi/summary/ora_v1/totals`
      )
        .then(response => {
          // console.log("Summary");
          this.num_dbs = response.data[0].num_dbs;
          this.num_customers = response.data[0].num_customers;

          // console.log(response.data);
          tries = 0;
  
        })
        .catch(error => {
          console.log("Main-Load Summary Error:", error);
        });
      tries -= 1;
    }
    
    await API.get("dbcsiAPI", `/dbcsi/customers`)
      .then(response => {
        // console.log("Main: I am here3");
        this.CustomerChoices = response.data;
        tries = 0;
        // console.log(this.genItems);
      })
      .catch(error => {
        console.log("Main Customer Error:", error);
      });

    
    tries = 5;
    
    while (tries > 0) {
      
      tries--;
      await API.get("dbcsiAPI", `/dbcsi/collections`)
        .then(response => {
          // console.log("Main: I am here3");
          this.collection_list = response.data;
          if (response.success) {
              tries = 0;
          } else {
            console.log("Main. Could not load collections.  Will retry.  Attempts Left:", (tries) );
          }    
          // console.log(this.genItems);
        })
        .catch(error => {
          // console.log("Main Error:", error);
          console.log("Error(timeout?).  Will retry loading collections.  Attempts Left:", (tries));
          this.collection_list[0].db_name+=" ..";
        });
    }    

      await API.get(
        "dbcsiAPI",
        `/dbcsi/summary/ora_v1/platforms`
      )
        .then(response => {
          // console.log("Summary");
          this.platforms=response.data;
        })
        .catch(error => {
          console.log("Main-Load Summary Platforms Error:", error);
        });

      await API.get(
        "dbcsiAPI",
        `/dbcsi/summary/ora_v1/versions`
      )
        .then(response => {
          // console.log("Summary");
          this.versions=response.data;
        })
        .catch(error => {
          console.log("Main-Load Summary Versions Error:", error);
        });

      await API.get(
        "dbcsiAPI",
        `/dbcsi/summary/ora_v1/features`
      )
        .then(response => {
          // console.log("Summary");
          this.features=response.data;
        })
        .catch(error => {
          console.log("Main-Load Summary Features Error:", error);
        });

      await API.get(
        "dbcsiAPI",
        `/dbcsi/summary/ora_v1/instances`
      )
        .then(response => {
          // console.log("Summary");
          this.instances=response.data;
        })
        .catch(error => {
          console.log("Main-Load Summary Instances Error:", error);
        });

/*
    var myChunk = [];
    this.collection_group = [];
    var g_id = 0;
    //chunk the collections into group of 3
    for (var ii = 0; ii < this.collection_list.length; ii++) {
      // console.log('Main10')
      
      myChunk.push(this.collection_list[ii]);
      g_id++;
      if (g_id > 2) {
              // console.log('Main11')
        this.collection_group.push({
          group_id: this.collection_group.length,
          collection_list: myChunk
        });
        myChunk = [];
        g_id = 0;
      }
      
    }
    //flush the last chunk
    if (myChunk) {
            // console.log('Main12')
      this.collection_group.push({
        group_id: this.collection_group.length,
        collection_list: myChunk
      });
      myChunk = [];
    }
    // console.log("Main: I am here4");
*/    
  },
  methods: {
    stringToHex (str)  {
      let hex = '';
      for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        const hexValue = charCode.toString(16);
    
        // Pad with zeros to ensure two-digit representation
        hex += hexValue.padStart(2, '0');
      }
      return hex;
    },
    async doSearch() {
      this.collection_list = [{ collection_id: "0", db_name: "Searching..." }];
      let qsp = {};
      if (this.searchString) qsp.searchString = this.searchString;
      if (this.CustomerFilter && this.CustomerFilter !== 'xxALL') qsp.customer = this.CustomerFilter;
      let options = Object.keys(qsp).length > 0 ? {queryStringParameters: qsp} : {};
      await API.get("dbcsiAPI", `/dbcsi/collections`, options)
        .then(response => {
          this.collection_list = response.data;
        })
        .catch(error => {
          console.log("Search Error:", error);
        });
    },
    clearSearch() {
      this.searchString = '';
      this.CustomerFilter = 'xxALL';
      this.doSearch();
    },
    onCustomerChange() {
      this.searchString = '';
      this.doSearch();
    }
  },
  computed: {
    collection_group_filtered() {
    var myChunk = [];
    var local_collection_group = [];
    var g_id = 0;
    //chunk the collections into group of 3
    // console.log(this.collection_list.length);
    for (var ii = 0; ii < this.collection_list.length; ii++) {
      // console.log('Main10')
      
        myChunk.push(this.collection_list[ii]);
        g_id++;
        if (g_id > 2) {
                // console.log('Main11')
          local_collection_group.push({
            group_id: local_collection_group.length,
            collection_list: myChunk
          });
          myChunk = [];
          g_id = 0;
        }
    }
    //flush the last chunk
    if (myChunk) {
            // console.log('Main12')
      local_collection_group.push({
        group_id: local_collection_group.length,
        collection_list: myChunk
      });
      myChunk = [];
    }  
       return local_collection_group;
    },
  }  
};
</script>

<style>
</style>
